import React from 'react';
import { Link } from 'react-router-dom';
import { MDBFooter, MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit';
import './Footer.css';
import lImg from '../img/looogo.png';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Componente combinado para Link con scroll
  const ScrollToTopLink = ({ to, children, className }) => {
    const handleClick = () => {
      scrollToTop();
    };

    return (
      <Link to={to} className={className} onClick={handleClick}>
        {children}
      </Link>
    );
  };

  return (
    <MDBFooter bgColor="light" className="text-center text-lg-start text-muted custom-footer">


      <section className="">
        <MDBContainer className="text-center text-md-start mt-5">
          <MDBRow className="mt-3">
            <MDBCol md="3" lg="4" xl="3" className="mx-auto mb-4">
              <h6 className="text-uppercase fw-bold mb-4">
                <MDBIcon icon="gem" className="me-3" />
                <img src={lImg} alt="Maderas Estufadas del Guadiana" />
              </h6>
              <p></p>
            </MDBCol>

            <MDBCol md="2" lg="2" xl="2" className="mx-auto mb-4">
              <h6 className="text-uppercase fw-bold mb-4">Products</h6>

              <p>
                <ScrollToTopLink to="/products" className="text-reset">
                  Beds
                </ScrollToTopLink>
              </p>
              <p>
                <ScrollToTopLink to="/products" className="text-reset">
                  Coves
                </ScrollToTopLink>
              </p>
              <p>
                <ScrollToTopLink to="/products" className="text-reset">
                  Casung
                </ScrollToTopLink>
              </p>
              <p>
                <ScrollToTopLink to="/products" className="text-reset">
                  Stops
                </ScrollToTopLink>
              </p>
            </MDBCol>

            <MDBCol md="3" lg="2" xl="2" className="mx-auto mb-4">
              <h6 className="text-uppercase fw-bold mb-4">Useful Links</h6>
              <p>
                <ScrollToTopLink to="/home" className="text-reset">
                  Home
                </ScrollToTopLink>
              </p>
              <p>
                <ScrollToTopLink to="/about" className="text-reset">
                  About
                </ScrollToTopLink>
              </p>
              <p>
                <ScrollToTopLink to="/products" className="text-reset">
                  Products
                </ScrollToTopLink>
              </p>
              <p>
                <ScrollToTopLink to="/contact" className="text-reset">
                  Contact
                </ScrollToTopLink>
              </p>
              <p>
                <ScrollToTopLink to="/login" className="text-reset">
                  Login
                </ScrollToTopLink>
              </p>
              <p>
                <ScrollToTopLink to="/LoginAdmin" className="text-reset">
                  Admin
                </ScrollToTopLink>
              </p>
            </MDBCol>

            <MDBCol md="4" lg="3" xl="3" className="mx-auto mb-md-0 mb-4">
              <h6 className="text-uppercase fw-bold mb-4">Contact</h6>
              <p>
                <MDBIcon icon="home" className="me-2" />
                Durango, Durango, Mexico
              </p>
              <p>
                <MDBIcon icon="envelope" className="me-3" />
                megnasa21@gmail.com
              </p>
              <p>
                <MDBIcon icon="phone" className="me-3" /> +52 618 824 6172
              </p>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>

      <div className="text-center p-4" style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
        © {new Date().getFullYear()} Copyright © 2024 - Created by WingWeb
        <ScrollToTopLink className="text-reset fw-bold" to="#!"></ScrollToTopLink>
      </div>
    </MDBFooter>
  );
};

export default Footer;